// Swap TILE_URL for your own tile server (e.g. tileserver-gl) if you ever need fully self-hosted tiles.
export const TILE_URL = "https://tile.openstreetmap.org/{z}/{x}/{y}.png"

export const TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
